import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { FiCheckCircle, FiXCircle } from 'react-icons/fi'
import { api } from '../../services/api'
import { useAuth } from '../../contexts/AuthContext'
import {
  Container,
  SuccessIcon,
  Title,
  Message,
  InfoCard,
  InfoRow,
  ButtonsContainer,
  PrimaryButton,
  SecondaryButton,
  LoadingContainer,
  ErrorContainer,
} from './styles'

export function CheckoutSuccess() {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')
  const { checkAuth } = useAuth()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [sessionData, setSessionData] = useState(null)

  useEffect(() => {
    const verifySession = async () => {
      if (!sessionId) {
        setError('Sessão inválida')
        setLoading(false)
        return
      }

      try {
        const { data } = await api.get(`/stripe/checkout-session/${sessionId}`)

        if (data.status === 'complete' && data.paymentStatus === 'paid') {
          setSessionData(data)
          await checkAuth()
        } else {
          setError('Pagamento não confirmado')
        }
      } catch (err) {
        console.error('Error verifying session:', err)
        setError('Erro ao verificar pagamento')
      } finally {
        setLoading(false)
      }
    }

    verifySession()
  }, [sessionId, checkAuth])

  if (loading) {
    return (
      <Container>
        <LoadingContainer>
          <div className="spinner" />
          <p>Verificando seu pagamento...</p>
        </LoadingContainer>
      </Container>
    )
  }

  if (error || !sessionData) {
    return (
      <Container>
        <ErrorContainer>
          <div className="error-icon">
            <FiXCircle size={50} />
          </div>
          <h2>Ops! Algo deu errado</h2>
          <p>{error || 'Não foi possível verificar seu pagamento. Entre em contato com o suporte.'}</p>
          <ButtonsContainer>
            <PrimaryButton to="/pricing">Voltar para Planos</PrimaryButton>
            <SecondaryButton to="/">Ir para Início</SecondaryButton>
          </ButtonsContainer>
        </ErrorContainer>
      </Container>
    )
  }

  return (
    <Container>
      <SuccessIcon>
        <FiCheckCircle size={60} />
      </SuccessIcon>

      <Title>Pagamento Confirmado!</Title>

      <Message>
        Sua assinatura foi ativada com sucesso. Agora você tem acesso ilimitado a todas as calculadoras de engenharia!
      </Message>

      <InfoCard>
        <InfoRow>
          <span className="label">Status do Pagamento</span>
          <span className="value" style={{ color: '#22c55e' }}>
            ✓ Confirmado
          </span>
        </InfoRow>
        <InfoRow>
          <span className="label">Email</span>
          <span className="value">{sessionData.customerEmail}</span>
        </InfoRow>
        <InfoRow>
          <span className="label">Tipo de Plano</span>
          <span className="value">Acesso Ilimitado</span>
        </InfoRow>
      </InfoCard>

      <Message style={{ fontSize: '1rem', marginTop: '24px', marginBottom: '16px' }}>
        Um recibo foi enviado para seu email. Você pode gerenciar sua assinatura a qualquer momento na página de planos.
      </Message>

      <ButtonsContainer>
        <PrimaryButton to="/">Começar a Calcular</PrimaryButton>
        <SecondaryButton to="/pricing">Gerenciar Assinatura</SecondaryButton>
      </ButtonsContainer>
    </Container>
  )
}
